import React, { Component } from 'react';
import AuthService from '../../services/api/auth';
import LoadingModal from '../../components/LoadingModal';
import { Link } from 'react-router-dom';
import ErrorList from '../../components/ErrorList';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as registerActions from './actions/';
import ServicesStatusOverview from '../../components/ServicesStatusOverview';
import BCAAMembership from '../../components/BCAAMembership';
import { returnToSelector } from '../../redux/application/selector';
import { setReturnTo } from '../../redux/application/actions';
import { selectFleet } from '../../redux/cities/actions';
import { selectedFleetSelector } from '../../redux/cities/selector';
import helper from '../../helpers';

class StatusScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            steps: [],
            errors: [],
            bcaaErrors: [],
            services: [],
            is_bcaa_enabled: (window.VULOG_CONFIG && window.VULOG_CONFIG.ENABLE_BCAA_MEMBERSHIP) || false,
            is_multi_service: false,
            is_payment_pending: false,
            manual_approval: false,
            bcaa: {
                member: false,
                memberSince: null,
                postalCode: null,
                input1: null,
                input2: null,
                input3: null,
            },
        };
    }

    componentDidMount() {
        //this is a new session, remove cookie;
        this.loadAccountStatus();
        this.props.setStep(-1);
    }

    updateBCAAFields(fieldName, data) {
        this.setState({
            bcaa: {
                ...this.state.bcaa,
                [fieldName]: data,
            },
        });
    }

    submitBtn() {
        if (this.state.is_bcaa_enabled && this.state.bcaa.member) {
            this.finalRegistrationStep();
        } else {
            this.redirectTo();
        }
    }

    async finalRegistrationStep() {
        let errors = [];
        let bcaaRequestObject = {
            member: this.state.bcaa.member,
            memberSince: this.state.bcaa.memberSince,
            membershipNumber: [620, this.state.bcaa.input1, this.state.bcaa.input2, this.state.bcaa.input3].join(''),
            postalCode: this.state.bcaa.postalCode,
        };

        if (!/\d{16}/.test(bcaaRequestObject.membershipNumber) || bcaaRequestObject.membershipNumber.length !== 16) {
            errors.push('BCAA_ERROR_MEMBERSHIP_NUMBER');
        }

        if (!/\d{4}/.test(bcaaRequestObject.memberSince) || bcaaRequestObject.memberSince.length !== 4) {
            errors.push('BCAA_ERROR_MEMBER_SINCE');
        }

        if (
            /([a-zA-Z][a-zA-Z]|[0-9][0-9])/.test(bcaaRequestObject.postalCode) ||
            bcaaRequestObject.postalCode.length > 12 ||
            /^\d.*$/.test(bcaaRequestObject.postalCode)
        ) {
            errors.push('BCAA_ERROR_POSTAL_CODE');
        }

        if (errors.length > 0) {
            return this.setState({
                bcaaErrors: errors,
            });
        }

        if (this.state.bcaaErrors.length === 1 && this.state.bcaaErrors[0] === 'BCAA_ERROR_UNAVAILABLE') {
            bcaaRequestObject.member = false;
        }

        try {
            const bcaaResponse = await AuthService.processBCAAMembership(bcaaRequestObject);
            if (!bcaaResponse.success) {
                this.setState({
                    bcaaErrors: [bcaaResponse.message],
                });
            } else {
                this.redirectTo();
            }
        } catch (e) {
            this.setState({
                bcaaErrors: [window.VULOG_TRANSLATE('BCAA_MEMBERSHIP_ERROR')],
            });
        }
    }

    redirectTo() {
        const { returnTo, onSelectFleet, selectedFleet } = this.props;
        const returnToURL = returnTo;
        const { onSetReturnTo } = this.props;
        onSetReturnTo('');
        const finalUrlParsed = window.VULOG_CONFIG.FINAL_URL.replace(
            '{message}',
            window.encodeURIComponent(window.VULOG_TRANSLATE('FINAL_URL_MESSAGE'))
        ).replace('{title}', window.encodeURIComponent(window.VULOG_TRANSLATE('FINAL_URL_TITLE')));

        // if we are in development env, we clear the selected city for tests
        if (selectedFleet && process.env.NODE_ENV === 'development') {
            onSelectFleet('');
        }

        const refreshToken = localStorage.getItem('refreshToken');

        if (!returnToURL) {
            localStorage.removeItem('refreshToken');
        }

        returnToURL
            ? (document.location = `${returnToURL}?refreshToken=${refreshToken}`)
            : (document.location = finalUrlParsed);
    }

    getServicesOverview() {
        AuthService.getServices().then(data => {
            /**
             * only persist requested services
             */
            this.setState({
                services: data.filter(service => service.registrationRequested),
            });
        });
    }

    loadAccountStatus() {
        this.getServicesOverview();
        AuthService.getAccountStatus().then(response => {
            const isMultiService = window.VULOG_CONFIG.IS_MULTI_SERVICE;
            let next = response.next;
            window.VULOG_CONFIG.STEPS = [...response.steps];
            if (response.next === '/register/services') {
                let foundUnfinishedStep = false;
                response.steps.forEach(item => {
                    if (item.title === 'SERVICES') {
                        return;
                    }
                    if (!item.success) {
                        foundUnfinishedStep = true;
                    }
                });

                if (!foundUnfinishedStep) {
                    next = null;
                }
            }

            if (next === '/register/status') {
                next = null;
            }

            if (!next) {
                //inject here serviceOverview
            }

            if (next === '/register/process') {
                return AuthService.processApplication().then(() => {
                    this.loadAccountStatus();
                });
            }

            this.setState({
                loading: false,
                is_multi_service: isMultiService,
                steps: response.steps.filter(i => !!!i.hide),
                is_business: response.is_business,
                next,
                manual_approval: response.manual_approval === 1,
                is_payment_pending: response.is_payment_pending,
            });
        });
    }

    render() {
        return (
            <div className="container-fluid wrapper">
                <div className="d-flex flex-column full-height menu-bar-bottom">
                    <h3 className="page__title">{window.VULOG_TRANSLATE('Almost ready to hit the road!')}</h3>

                    <div className="f-container flex-grow-1 no-border" style={{ marginBottom: 0, paddingTop: 0 }}>
                        {window.VULOG_CONFIG.ERROR_DISPLAY_TOP && <ErrorList errors={this.state.errors} />}
                        <ul className="check-list">
                            {this.state.steps.map(i => {
                                return (
                                    <li key={i.screen}>
                                        <span className="check-list__label">
                                            {window.VULOG_TRANSLATE(`${i.screen}_STATUS`)}
                                        </span>{' '}
                                        <span className={'check-list__status ' + JSON.stringify(i.success)}></span>
                                    </li>
                                );
                            })}
                        </ul>

                        {!window.VULOG_CONFIG.ERROR_DISPLAY_TOP && <ErrorList errors={this.state.errors} />}

                        {!this.state.next && this.state.is_multi_service && this.state.services.length > 0 && (
                            <ServicesStatusOverview
                                services={this.state.services}
                                manualApproval={this.state.manual_approval}
                                paymentPending={this.state.is_payment_pending}
                            />
                        )}

                        {!this.state.next &&
                            !this.state.is_multi_service &&
                            !this.state.manual_approval &&
                            !this.state.is_payment_pending && (
                                <div className="update__container">
                                    <h4 className="update__title">{window.VULOG_TRANSLATE('Congratulations !')}</h4>
                                    <div className="update__msg">
                                        <p>
                                            {window.VULOG_TRANSLATE(
                                                'Your account has been approved. Enjoy your rides!'
                                            )}
                                        </p>
                                    </div>
                                </div>
                            )}

                        {!this.state.next &&
                            !this.state.is_multi_service &&
                            !this.state.manual_approval &&
                            this.state.is_payment_pending && (
                                <div className="update__container">
                                    <h4 className="update__title">{window.VULOG_TRANSLATE('PAYMENT_PENDING_TITLE')}</h4>
                                    <div className="update__msg">
                                        <p>{window.VULOG_TRANSLATE('PAYMENT_PENDING_MESSAGE')}</p>
                                    </div>
                                </div>
                            )}

                        {!this.state.next && !this.state.is_multi_service && this.state.manual_approval && (
                            <div className="update__container">
                                <h4 className="update__title" style={{ margin: 0 }}>
                                    {window.VULOG_TRANSLATE('Almost there...')}
                                </h4>
                                <div className="update__msg">
                                    <p>{window.VULOG_TRANSLATE('Thanks for completing registration')}</p>
                                </div>
                            </div>
                        )}
                    </div>

                    {this.state.is_bcaa_enabled && !this.state.next && !this.state.loading ? (
                        <React.Fragment>
                            <ErrorList errors={this.state.bcaaErrors} />
                            <BCAAMembership updateField={this.updateBCAAFields.bind(this)} data={this.state.bcaa} />
                        </React.Fragment>
                    ) : null}

                    {window.VULOG_CONFIG.HAS_PROFESSIONAL_LINK && (
                        <div>
                            <h6>{window.VULOG_TRANSLATE('Do you have your own business ?')}</h6>
                            <p>{helper.generateVATText()}</p>
                        </div>
                    )}

                    <div className="d-flex mt-auto mb-1-5rem" style={{ flexDirection: 'column' }}>
                        {this.state.next && (
                            <button
                                className="btn btn-primary btn-block mr-auto ml-auto"
                                onClick={() => {
                                    this.props.history.push(this.state.next);
                                }}
                            >
                                {window.VULOG_TRANSLATE('Continue')}
                                <i className="material-icons va-middle reg">keyboard_arrow_right</i>
                            </button>
                        )}

                        {!this.state.next && (
                            <button
                                className="btn btn-primary btn-block mr-auto ml-auto"
                                onClick={this.submitBtn.bind(this)}
                            >
                                {window.VULOG_TRANSLATE('Submit')}
                                <i className="material-icons va-middle reg">keyboard_arrow_right</i>
                            </button>
                        )}

                        {this.state.is_multi_service && !this.state.next && !this.state.is_business && (
                            <div style={{ textAlign: 'center', marginTop: 10 }}>
                                <Link to={'/register/services'}>{window.VULOG_TRANSLATE('Add new service')}</Link>
                            </div>
                        )}
                    </div>
                    <LoadingModal loading={this.state.loading} message={'ACCOUNT_STATUS_LOADING_MESSAGE'} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    returnTo: returnToSelector(state),
    selectedFleet: selectedFleetSelector(state),
});
/**
 * Get actions and pass them as props to Component
 * @param dispatch
 * @returns {{}|B|N}
 */

const mapDispatchToProps = dispatch => ({
    onSetReturnTo: bindActionCreators(setReturnTo, dispatch),
    onSelectFleet: bindActionCreators(selectFleet, dispatch),
    ...bindActionCreators(registerActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(StatusScreen);
